module.exports = __webpack_public_path__ + "static/media/img2-1.7368d52a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/nutricheck_foliar/N/img2-1.png
// module id = 2315
// module chunks = 3